import React, { FC, useMemo } from 'react';
import { toast } from 'react-toastify';
import BottomSlider from '../../components/BottomSlider/BottomSlider';
import Button from '../../components/Button/Button';
import Form from '../../components/Form/Form';
import { FormFieldT, VersionT } from '../../models/models';
import { TOAST_DURATION } from '../../utils/helpers/constants';
import { isMobileOrTablet } from '../../utils/helpers/mediaQueries';

import styles from './addVersionSlider.module.scss';

type AddVersionSliderPropTypes = {
    visible: boolean;
    item?: VersionT;
    elements: any;
    fields: FormFieldT[];
    onSubmit: (data: any) => void;
    onClose: () => void;
    onDelete: () => void;
    versionsAmount: number;
    index: number;
}

const AddVersionSlider: FC<AddVersionSliderPropTypes> = (props) => {
    const {
        visible,
        item,
        onSubmit,
        onDelete,
        onClose,
        elements,
        fields,
        versionsAmount,
        index,
    } = props;

    const isCreateMode = useMemo(() => isMobileOrTablet() && (!item.RequiredLength || !item.Name), []);

    const handleSubmit = (data: any) => {
        onSubmit(data);
        onClose();
    };

    const handleClose = () => {
        if (versionsAmount > 1) {
            if (isCreateMode) {
                onDelete();
            }
            onClose();
        } else {
            toast('You have to create at least one version', {
                type: 'error',
                autoClose: TOAST_DURATION,
            });
        }
    };

    return (
        <BottomSlider visible={visible} onClose={handleClose} title={isCreateMode ? 'Add version' : 'Edit version'}>
            <div className={styles.wrapper}>
                <Form
                    fields={fields}
                    onSubmit={handleSubmit}
                    formID={`add-version-form-${item.AdId}${index}`}
                    columns={1}
                    elements={elements()}
                />
                <div className={styles.buttonWrapper}>
                    <Button form={`add-version-form-${item.AdId}${index}`}>
                        {isCreateMode ? 'Add version' : 'Save changes'}
                    </Button>
                </div>
            </div>
        </BottomSlider>
    );
};

export default AddVersionSlider;